export * from './productSummary.variants.defaults';
